<template>
  <el-form :inline="true" :model="queryParam" class="mainSearch">
    <el-page-header @back="goback" style="margin-bottom: 20px">
      <template #content>
        <span class="text-large font-600 mr-3">{{ title }}成员 </span>
      </template>
    </el-page-header>
  </el-form>

  <el-row>
    <el-col :span="24">
      <div style="background: #fff; padding: 20px 20px 0; text-align: right">
        <el-autocomplete
          style="width: 200px"
          clearable
          :trigger-on-focus="false"
          v-model="queryUserParam.nickname"
          :fetch-suggestions="querySearchAsync"
          placeholder="搜索用户并点击添加组用户"
          @select="handleSelect"
        />
      </div>
    </el-col>
  </el-row>


  <el-row class="mainTableBox">
    <el-col :span="24" class="mpadding">
      <el-table
        :data="tableData"
        class="mainTable"
        default-expand-all
        row-key="groupid"
      >
        <el-table-column label="用户名" prop="username" />
        <el-table-column label="昵称" prop="nickname" />
        <el-table-column label="操作" fixed="right" width="260">
          <template #default="scope">
            <el-popconfirm
              confirm-button-type="danger"
              confirm-button-text="确定"
              cancel-button-text="取消"
              icon-color="#626AEF"
              title="您确定要删除吗？"
              @confirm="doGroupUserDelete(scope.$index, scope.row)"
            >
              <template #reference>
                <el-link
                  size="small"
                  type="danger"
                  v-hasPermission="['system:group']"
                  >删除</el-link
                >
              </template>
            </el-popconfirm>
          </template>
        </el-table-column>
      </el-table>
    </el-col>
  </el-row>

  <el-row class="mainTableBottom">
    <el-col :span="8"
      ><div>
        <!-- <el-button
          type="danger"
          >添加权组</el-button> -->
      </div></el-col
    >
    <el-col :span="16">
      <div style="float: right">
        <el-pagination
          :hide-on-single-page="true"
          v-model:page-size="queryParam.pageSize"
          :page-sizes="[10, 15, 20, 30]"
          :background="true"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          @size-change="changeChangeSize"
          @current-change="changePage"
        />
      </div>
    </el-col>
  </el-row>
</template>
<script setup>
import { onMounted, ref } from "vue";
import { ElMessage } from "element-plus";

import { useRouter } from "vue-router";

import { listGroupUser, saveGroupUser, deleteGroupUser } from "@/api/group";
import { listUser } from "@/api/user";

const router = useRouter();

const tableData = ref([]);

const total = ref(0);
const pageSize = ref(15); //每页显示条数

const groupid = ref(router.currentRoute.value.params.id);
const title = ref(router.currentRoute.value.query.name);

//搜索查询
const queryUserParam = ref({
  pageNo: 1,
  pageSize: 10,
  nickname: "",
});

// let timeout
const querySearchAsync = (queryString, cb) => {
  if (queryString && queryString.length > 0) {
    queryUserParam.value.nickname = queryString;
    try {
      listUser(queryUserParam.value).then((res) => {
        // 赋值给建议列表，渲染到页面
        let list = res.data.extend.pages.list;
        // 如果list.length等于0，则代表没有匹配到结果。手动给list添加一条提示信息
        if (!queryUserParam.value.nickname || list.length <= 0) {
          list.push({
            id: "-1",
            value: "未查询到相关用户",
          });
          // 调用 callback 返回建议列表的数据
          cb(list);
        } else {
          list = list.map((item) => {
            return {
              value: `${item.nickname}`,
              id: `${item.userid}`,
            };
          });
          list = list.filter((item) => {
            return item.value.indexOf(queryUserParam.value.nickname) > -1;
          });
          // 调用 callback 返回建议列表的数据
          cb(list);
        }
      });
    } catch (error) {
      console.log(error);
    }
  }
};

const handleSelect = (item) => {
  queryUserParam.value.nickname = item.value;
  let checkFilter = tableData.value.filter((ele) => ele.userid == item.id);
  if (checkFilter.length > 0) {
    ElMessage.error("已经存在用户");
    return;
  }

  //添加组用户
  saveGroupUser({ groupid: groupid.value, userid: item.id }).then((res) => {
    if (res.data.code == 1) {
      getListGroupUser();
    }
  });
};

const doGroupUserDelete = (index, row) => {
  deleteGroupUser({ id: row.id }).then((res) => {
    if (res.data.code == 1) {
      tableData.value.splice(index, 1);
    }
  });
};

//返回
const goback = () => {
  router.go(-1);
};

//搜索查询
const queryParam = ref({
  pageNo: 1,
  pageSize: pageSize.value,
  name: "",
  groupid,
});

onMounted(() => {
  getListGroupUser();
});

//分页
const changePage = (current) => {
  queryParam.value.pageNo = current;
  getListGroupUser();
};
const changeChangeSize = (size) => {
  pageSize.value = size;
  queryParam.value.pageSize = size;
  getListGroupUser();
};
//用户列表API
const getListGroupUser = () => {
  listGroupUser(queryParam.value).then((res) => {
    tableData.value = res.data.extend.pages.list;
    total.value = res.data.extend.pages.total;
    queryParam.value.pageSize = pageSize.value;
  });
};
</script>
